import { render, staticRenderFns } from "./provincialQualification.vue?vue&type=template&id=930be0be&scoped=true&"
import script from "./provincialQualification.vue?vue&type=script&lang=js&"
export * from "./provincialQualification.vue?vue&type=script&lang=js&"
import style0 from "./provincialQualification.vue?vue&type=style&index=0&id=930be0be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930be0be",
  null
  
)

export default component.exports